import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductLandingPagesRanking } from '@/features/public-pages/Ranking'

export const Route = createFileRoute('/_event/p/ranking')({
  staticData: {
    isPublic: true
  },
  component: DigitalProductLandingPagesRankingPage
})

function DigitalProductLandingPagesRankingPage() {
  return <DigitalProductLandingPagesRanking />
}
